export type CommonDescriptionAttribute = {
  code: 'description';
  type?: 'text';
  title?: string;
  value: string | null;
  defaultValue?: string | null;
  displayValue?: string | null;
  extra?: any;
  required?: boolean;
  override: boolean;
  hasPublishControl?: boolean;
  publish: boolean;
};
